import * as React from 'react';

export const SvgAssetCautionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 17" {...props}>
    <g fill="#E0182D" fillRule="evenodd">
      <path d="M7.251 6h1.5v5h-1.5z" />
      <circle cx={8.001} cy={12.75} r={1} />
      <path
        fillRule="nonzero"
        d="M.751 16a.75.75 0 01-.67-1.085L7.33.415a.75.75 0 011.34 0l7.25 14.5A.75.75 0 0115.25 16H.751zm1.213-1.5h12.073L8.001 2.427 1.964 14.5z"
      />
    </g>
  </svg>
);
